<script setup lang="ts">
import {onBeforeUnmount, onMounted, ref} from 'vue'
import {IScreenShareSource} from 'toolify-desktop/src/main/types/IScreenShareSource'
import ScreenSharePickerModal from '@toolify/client/src/modules/call/components/ScreenSharePickerModal.vue'
import {useIsElectron} from '@toolify/client/src/modules/electron/composables/useIsElectron'

const {isElectron} = useIsElectron()
const sources = ref<IScreenShareSource[]>([])

function onPickerOpen(pickerSources: IScreenShareSource[]) {
  sources.value = pickerSources || []
}

function onPickerClose() {
  sources.value = []
}

function onSelect(sourceId: string) {
  sources.value = []
  void window.electronAPI?.selectScreenShareSource?.(sourceId)
}

function onCancel() {
  if (!sources.value.length) {
    return
  }
  sources.value = []
  void window.electronAPI?.selectScreenShareSource?.(null)
}

onMounted(() => {
  if (!isElectron) {
    return
  }
  window.electronAPI.onScreenSharePickerOpen?.(onPickerOpen)
  window.electronAPI.onScreenSharePickerClose?.(onPickerClose)
})

onBeforeUnmount(() => {
  if (!isElectron) {
    return
  }
  window.electronAPI.offScreenSharePickerOpen?.(onPickerOpen)
  window.electronAPI.offScreenSharePickerClose?.(onPickerClose)
})
</script>

<template>
  <ScreenSharePickerModal
    v-if="sources.length"
    :sources="sources"
    @select="onSelect"
    @cancel="onCancel"
  />
</template>
